import { render, staticRenderFns } from "./DownloadNominationsModal.vue?vue&type=template&id=116ff992&"
import script from "./DownloadNominationsModal.vue?vue&type=script&lang=js&"
export * from "./DownloadNominationsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports